import { render, staticRenderFns } from "./detailed-content.vue?vue&type=template&id=c1aa99f2&scoped=true&"
import script from "./detailed-content.vue?vue&type=script&lang=js&"
export * from "./detailed-content.vue?vue&type=script&lang=js&"
import style0 from "./detailed-content.vue?vue&type=style&index=0&id=c1aa99f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1aa99f2",
  null
  
)

export default component.exports